module.exports = __webpack_public_path__ + "img/Flux28 typography.74ee7a9e.webp";